import React, { useState } from 'react';
import { api } from './services/apiService';
import constants from './constants';
import logo from './assets/logo_LMF.jpg';
import UploadCV from './components/UploadCV';
import StartButton from './components/StartButton';
import Questions from './components/Questions';
import Results from './components/Results';
import Footer from './components/Footer';
import './styles/App.css';

const App = () => {
  // Log des variables d'environnement et de l'URL du backend
  console.log('%c[DEBUG] Environment & Backend URL', 'background: #222; color: #bada55');
  console.log('Backend URL:', process.env.REACT_APP_BACKEND_URL);
  console.log('NODE_ENV:', process.env.NODE_ENV);
  console.log('All REACT_APP_ variables:', Object.keys(process.env)
    .filter(key => key.startsWith('REACT_APP_'))
    .reduce((obj, key) => {
      obj[key] = process.env[key];
      return obj;
    }, {})
  );

  if (!process.env.REACT_APP_BACKEND_URL) {
    console.error('Erreur : l\'URL du backend n\'est pas définie');
  }

  const [currentStep, setCurrentStep] = useState("upload");
  const [cvText, setCvText] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [responses, setResponses] = useState({});
  const [results, setResults] = useState(null);

  const goToNextStep = (step) => setCurrentStep(step);

  const handleScoring = async () => {
    const payload = {
      cv_text: cvText,
      job_description: constants.JOB_DESCRIPTION,
      questions_and_responses: Object.entries(responses).map(([index, response]) => ({
        question: questions[index]?.text,
        response,
      })),
    };

    try {
      const data = await api.post('/scoring', payload);
      setResults(data);
      goToNextStep('results');
    } catch (error) {
      console.error('Erreur lors de l\'appel à l\'API scoring :', error);
      alert('Une erreur s\'est produite lors de l\'évaluation. Veuillez réessayer.');
    }
  };

  return (
    <div className="app-container">
      <div className="app-content">
        <header className="app-header">
          <img src={logo} alt="Logo Leroy Merlin" className="app-logo" />
        </header>

        {currentStep === 'upload' && (
          <>
            <h1>Bienvenue dans votre espace d'évaluation des compétences</h1>
            <h3>
              Que vous soyez à la recherche d'un nouveau défi ou curieux de découvrir vos points forts,
              ce système est conçu pour vous accompagner dans votre parcours.
            </h3>
            <h3>
              Grâce à une analyse précise et adaptée, vous obtiendrez une synthèse de vos compétences ainsi
              qu'un score personnalisé pour évaluer votre adéquation avec le poste de vendeur chez Leroy Merlin.
            </h3>
            <UploadCV setCvText={setCvText} goToNextStep={() => goToNextStep('start')} />
          </>
        )}

        {currentStep === 'start' && (
          <div>
            <StartButton
              cvText={cvText}
              setQuestions={setQuestions}
              goToNextStep={() => goToNextStep('questions')}
            />
          </div>
        )}

        {currentStep === 'questions' && (
          <Questions
            questions={questions}
            responses={responses}
            setResponses={setResponses}
            onComplete={handleScoring}
          />
        )}

        {currentStep === 'results' && (
          <Results
            results={results}
            questionsResponses={Object.entries(responses).map(([index, response]) => ({
              question: questions[index]?.text,
              response,
            }))}
          />
        )}
      </div>
      <Footer />
    </div>
  );
};

export default App;